/**
 * Shared validation and constants for audio file uploads.
 */
import {
  AUDIO_CONTENT_TYPES,
  AUDIO_EXTENSIONS,
  MAX_FILE_SIZE_BYTES,
} from '~/shared/upload-constraints';

export { MAX_FILE_SIZE_BYTES };

/**
 * Checks if a file is a valid audio file based on MIME type or extension.
 */
export function isAudioFile(file: File): boolean {
  if (
    AUDIO_CONTENT_TYPES.some(
      (contentType) => contentType === file.type.toLowerCase(),
    )
  ) {
    return true;
  }
  const name = file.name.toLowerCase();
  return AUDIO_EXTENSIONS.some((ext) => name.endsWith(ext));
}
